import { render } from "./App.vue?vue&type=template&id=b79af358"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b79af358&lang=css"

import exportComponent from "/Users/joschabruning/Documents/MA/sem03/shelfgenerator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__